var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className + ' form-group'},[_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('textarea',{staticClass:"form-control",attrs:{"name":_vm.name,"id":_vm.id,"rows":_vm.rows,"required":_vm.required,"placeholder":_vm.placeholder}})])
}
var staticRenderFns = []

export { render, staticRenderFns }